import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
moment.locale('pt-BR');

@Pipe({
    name: 'pipeDateBrasil'
})
export class PipeDateBrasil implements PipeTransform {
    transform(date: string): string {
        return moment(date).format('DD/MM/YYYY')
    }
}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeDateBrasil.ts